import React from 'react';
import { Spin as AntSpin } from '@vertem-core/vertice-ds';
import { SpinProps } from 'antd/lib/spin';

const Spin: React.FC<SpinProps> = (props) => <AntSpin {...props} />;

export default Spin;
